/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import isNil from 'lodash/isNil';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { routerActions } from 'react-router-redux';
import {
  Button,
  Modal,
  Collapse,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import chplanActions from 'loraactions/chplan';
import styles from './styles.scss';

const defaultProps = {
  show: false,
};
const propTypes = {
  intl: React.PropTypes.any.isRequired,
  show: React.PropTypes.bool,
  onHide: React.PropTypes.func.isRequired,
  channelPlan: React.PropTypes.object.isRequired,
  deleteChannelPlan: React.PropTypes.func.isRequired,
  deleted: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
};

class DeleteChannelPlanModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      channelPlan: props.channelPlan,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'network.banddetail.deletemodal');
  }

  componentWillReceiveProps(nextProps) {
    const { show, deleted } = nextProps;
    if (show !== this.props.show) {
      this.setState({ show });
    }
    if (deleted !== this.props.deleted) {
      if (deleted.status === 'success') {
        const { pushState } = this.props;
        pushState('/network/chplans');
      } else if (deleted.status === 'failure') {
        this.setState({ error: deleted.error.code });
      }
    }
  }

  handleSubmit() {
    const { deleteChannelPlan } = this.props;
    const { channelPlan: { id } } = this.state;
    deleteChannelPlan(id);
  }

  render() {
    const { onHide, channelPlan } = this.props;
    const { show, error } = this.state;
    return (
      <Modal
        bsClass="aisz-modal-danger"
        show={show}
        onHide={onHide}
      >
        <Modal.Header closeButton>
          <div className="text-center">
            <i className="fa fa-exclamation-triangle" aria-hidden="true" />
            {' '}
            {this.intlMsg.msg('title')}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <p>
              {this.intlMsg.msg('title')}{' '}
              <strong>{channelPlan.name}({channelPlan.id})</strong> ?
            </p>
            <Button
              bsStyle="aisz-warning"
              onClick={onHide}
            >
              <i className="fa fa-repeat" aria-hidden="true" />
              {' '}
              {this.intlMsg.msg('cancel')}
            </Button>
            {' '}
            <Button
              bsStyle="aisz-danger"
              onClick={this.handleSubmit}
            >
              <i className="fa fa-trash-o" aria-hidden="true" />
              {' '}
              {this.intlMsg.msg('confirm')}
            </Button>
          </div>
          <Collapse in={!isNil(error)}>
            <div>
              <div className={styles.errorblock}>
                {this.intlMsg.errorMsg(error)}
              </div>
            </div>
          </Collapse>
        </Modal.Body>
      </Modal>
    );
  }
}

DeleteChannelPlanModal.defaultProps = defaultProps;
DeleteChannelPlanModal.propTypes = propTypes;

const mapStateToProps = state => ({
  deleted: state.chplan.deleteChannelPlan,
});
const mapDispatchToProps = {
  deleteChannelPlan: chplanActions.deleteChannelPlan,
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DeleteChannelPlanModal));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/ChannelView/coms/DeleteChannelPlanModal/index.jsx